<template>
	<div class="form-group">
		
		<form-label 
		v-if="label" 
		:class="labelClass"
		:for="id"
		v-html="$sanitize(label)" />

		<v-date-picker 
		class="input-date"
		:popover="{ visibility: 'click' }"
		:value="date" 
		:mode="mode"
		:select-attribute="attributes"
		@input="emit" 
		:minute-increment="5"
		:is24hr="true"
		clearable>
			<template v-slot="{ inputValue, inputEvents }">
			    
				<div class="input-group input-group-merge">

					<div class="input-group-text">
						<span class="bi bi-calendar"></span>
					</div>
					
					<input class="form-control"
				      :value="inputValue"
				      v-on="inputEvents"
				    />

				</div>

			</template>
		</v-date-picker>

		<form-errors v-bind="{errors}" />

	</div>
</template>

<script>
	export default {

		props: {

			id: {
				type: String,
				default() {
					return `input-date-${this._uid}`
				},
			},

			labelClass: {
				type: String,
				default: ''
			},

			mode: {
				type: String,
				default: 'date'
			},

			errors: {
				type: String,
				default: ''
			},

			value: [Date, String, Object],
			label: String,
			sublabel: String,
		},

		data() {
			return {
				props: {
					class: "form-control form-control-prepended"
				},
				attributes: {
					highlight: {
						style: { 
							'background-color' : '#335EEA'
						},
						contentStyle: { 
							'color' : 'white',
							'font-weight' : '700',
						}
					},
				},
			}
		},

		computed: {

			date() {
				if(!this.value)
					return null;

				return (this.value instanceof Date) 
				? this.value 
				: new Date(this.value);
			}
		},

		methods: {

			emit(value) {
				var date = value 
				? moment(value).format('YYYY-MM-DD HH:mm:ss')
				: ''
				
				this.$emit('input', date)
			}

		}
	}
</script>